export var CLASSNAME_PREFIX = 'cp-ma';
export var TRANSLATION_CONTEXT = 'myaccount';